var BlockView = require('views/block/base-block-view');
var ActionPlanTopicsCollectionView = require('views/block/action-plan/action-plan-topics-collection-view');
import { KeybindingService, keys } from 'services/keybinding-service';
var LocaleService = require('services/locale-service');

const { Enter } = keys;

var ActionPlanView = BlockView.extend({
  regions: {
    'actionPlan': '.action-plan'
  },

  load: function() {
    var self = this, moduleKey = this.model.get('module_key') || EF.module.get('key');
    this.model.set('moduleKey', moduleKey);
    this.targetModule = EF.module || EF.modules.find({ key: this.moduleKey });
    EF.actionPlanTopics.fetchWithResponses(moduleKey).done(function(_actionPlanItemResponses) {
      //EF.actionPlanTopics.reset(EF.actionPlanTopics.filter({module_id: 265}));
      self.bindView();
    });
  },

  bindView: function(beforePublishRender) {
    this.setResponses();
    this.setViewState();
    var self = this;
    self.collection = EF.actionPlanTopics;
    var actionPlanTopicsCollectionView = new ActionPlanTopicsCollectionView({
      collection: self.collection,
      region: 'actionPlan',
      model: self.model
    });
    self.subview('actionPlan', actionPlanTopicsCollectionView);
    self.$('.marked-down a').attr('target', '_blank');
    if(beforePublishRender) beforePublishRender();
    Chaplin.mediator.publish('block:action-plan:rendered', actionPlanTopicsCollectionView);
    this.toggleContinue();
    if(this.model.get('complete')) this.readyToGo();
    self.$el.find('.action-plan-topic,.action-plan-item').attr('tabindex', 0);
    let $activeActionPlanItems = $('.action-plan-topic.active').first().find('.action-plan-item');

    $activeActionPlanItems.each(function(index, elem) {
      let $elem = $(elem);
      let $sibling = $elem.siblings('.action-plan-item');
      let $allDisabledLinks = $activeActionPlanItems.find('.response-buttons .btn.disabled');

      setTimeout(function() {
        if($allDisabledLinks.length < 1) {
          $('.action-plan-topic.active').first().attr('role', 'alert').focus();

        } else {
          let $disabledLinks = $elem.find('.response-buttons .btn.disabled');

          if($disabledLinks.length > 0) {
            $sibling.attr('role', 'alert').focus();

          } else {
            $elem.attr('role', 'alert').focus();
          }
        }
      }, 0);
    });

    if(this.model.get('complete')) {
      $('#action-plan-complete').attr({'tabindex': 0, 'role': 'alert'}).focus();
    }
  },

  setViewState: function() {
    this.model.set('complete', !EF.actionPlanTopics.find({ active: true }));
    this.model.set('email', EF.enrollment.get('email'));
    this.render();
  },

  setActionPlanItemsCollection: function(actionPlanTopic) {
    var actionPlanItemsCollection = actionPlanTopic.get('action_plan_items_collection');
    if(!actionPlanItemsCollection) {
      var actionPlanItems = actionPlanTopic.get('action_plan_items');
      actionPlanItemsCollection = new EF.Collections.ActionPlanItemsCollection(actionPlanItems, { enrollment: EF.enrollment });
      actionPlanTopic.set('action_plan_items_collection', actionPlanItemsCollection);
      actionPlanTopic.set('anyActionPlanItems', actionPlanItems.length > 0);
    }
    return actionPlanItemsCollection;
  },

  setResponses: function() {
    var self = this, responses = EF.actionPlanTopics.actionPlanItemResponses;
    EF.actionPlanTopics.forEach(function(actionPlanTopic,index) {
      var actionPlanItemsCollection = self.setActionPlanItemsCollection(actionPlanTopic);
      var responseCount = actionPlanItemsCollection.length;
      actionPlanItemsCollection.forEach(function(actionPlanItem) {
        var actionPlanItemResponse = responses.find({ action_plan_item_id: actionPlanItem.get('id') });
        actionPlanItem.set('actionPlanItemResponse', actionPlanItemResponse);
        if(actionPlanItemResponse) responseCount -= 1;
      });
      actionPlanTopic.set('done', responseCount === 0);
      actionPlanTopic.set('active', responseCount > 0);
      actionPlanTopic.set('stepsComplete', LocaleService.t('actionPlan.stepsComplete', { currentStep: index+1, totalSteps: EF.actionPlanTopics.length }));
    });
  },

  toggleContinue: function() {
    var $email = this.$('#email-summary #email');
    var $continueBtn = this.$('#view-plan-btn');
    var $emailErrorMessage = this.$('#email-error');
    var continueHref = '#menu/action-plan-responses?key=' + this.model.get('moduleKey');
    if(this.$('#send-email').is(':checked')) {
      this.$('#send-email').attr('aria-checked', 'true');
      $email.show();

      if(/\S+@\S+\.\S+/.test($email.val())) {
        $continueBtn.attr('href', continueHref);
        $emailErrorMessage.hide();
      } else if($email.val().length > 0) {
        $continueBtn.attr('href', '#');
        $continueBtn.attr('onclick', 'return false;');
        $emailErrorMessage.show();
      } else {
        $continueBtn.attr('href', '#');
        $continueBtn.attr('onclick', 'return false;');
        $emailErrorMessage.hide();
      }

    } else {
      $email.hide();
      this.$('#send-email').attr('aria-checked', 'false');
      $continueBtn.attr('href', continueHref);
      $emailErrorMessage.hide();
    }
  },

  play: function() {
    var self = this;
    this.delegate('click', '.response-buttons a.btn', function(e) {
      var $actionPlanItem = $(e.currentTarget).closest('li.action-plan-item');
      var $link = $(e.currentTarget);
      $link.addClass('busy');
      var responseId = $link.closest('.response-buttons').data('id');
      var actionPlanItemResponse = EF.actionPlanTopics.actionPlanItemResponses.find({ id: responseId });
      if(!actionPlanItemResponse) {
        actionPlanItemResponse = new EF.Models.ActionPlanItemResponse({ action_plan_item_id: $actionPlanItem.data('id'), enrollment_id: EF.enrollment.get('id') }, { enrollment: EF.enrollment });
        var $otherResponse = $actionPlanItem.find('textarea.action-plan-item-response-other');
        if($otherResponse.length) { actionPlanItemResponse.set('other_response', $otherResponse.val()); }
      }
      actionPlanItemResponse.set('state', $link.data('state'));
      var topicId = $link.closest('.action-plan-topic').data('id');
      actionPlanItemResponse.save().done(function(data) {
        if(data.id) {
          actionPlanItemResponse.set('id', data.id);
          EF.actionPlanTopics.actionPlanItemResponses.add(actionPlanItemResponse);
        }
        self.bindView(function() {
          if(EF.actionPlanTopics.find({ id: topicId }).get('done')) {
            self.$el.find(`.action-plan-topic[data-id=${topicId}]`).addClass('last-done');
          }
        });
      });
      return false;
    });

    this.delegate('click', '#send-email', this.toggleContinue.bind(this));

    this.delegate('keydown', '#send-email',(e) => {
      KeybindingService.with(e).bind(Enter, () => $(e.target).click());
    });

    this.delegate('keydown', '#email', (_e) => {
      this.toggleContinue();
    });

    this.delegate('click', '.action-plan #view-plan-btn', function(_e) {
      var $email = this.$('#email-summary #email');
      var $emailErrorMessage = this.$('#email-error');
      if($('#send-email:checked').length > 0 && /\S+@\S+\.\S+/.test($email.val())) {
        Backbone.ajax({
          url: EF.url(`/sdk/enrollments/${EF.enrollment.get('id')}/action_plan_item_responses/email`),
          data: { module_key: self.model.get('moduleKey'), email: this.$el.find('#email-summary #email').val() }
        });
      } else {
        $emailErrorMessage.show();
      }
    });
  }

});

module.exports = ActionPlanView;
